import { setupOptimisticCheckoutMiddleware } from "./optimisticCheckoutMiddleware";

export const setupAllMiddleware = () => {
  setupOptimisticCheckoutMiddleware();
};
